// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Lhnr8","logo":"Header_logo__nZ7K6","navList":"Header_navList__FI4e0","btnContato":"Header_btnContato__89NMl"};